import { createFileRoute } from "@tanstack/react-router";
import { SEOPage } from "@/components/site/SEOPage";
import { Layout, Target, MousePointer2, Zap, ShieldCheck, TrendingUp, Search, Star, Globe, Smartphone, Code, Rocket, MessageCircle } from "lucide-react";

const ArticlePage = () => {
  const breadcrumbs = [
    { label: "Elite", href: "/" },
    { label: "Blog", href: "/blog" },
    { label: "Como Criar um Site para Captar Clientes IPTV", href: "/blog/como-criar-site-captar-clientes-iptv" }
  ];

  const sections = [
    {
      title: "Seu Site: O Vendedor que Nunca Dorme",
      content: (
        <div className="prose prose-invert max-w-none space-y-6 text-lg text-muted-foreground">
          <p>
            Em 2026, depender apenas de redes sociais é um risco para qualquer revendedor Master. Um <strong>site próprio para captar clientes IPTV</strong> é o seu terreno alugado no Google, onde você dita as regras. É uma ferramenta de automação que educa o cliente, tira dúvidas e faz o fechamento da venda enquanto você dorme ou foca na gestão do <strong>painel P2 PRO</strong>.
          </p>
          <p>
            Um site de alta conversão não precisa ser complexo, mas precisa ser estratégico. Ele deve ser focado em <strong>Landing Pages</strong>: páginas de destino criadas com um único objetivo – fazer o cliente clicar no botão de "Teste Grátis" ou "Assinar Agora". Ao exibir o design premium dos aplicativos <strong>One X e P2 PLAY</strong>, seu site ganha autoridade instantânea.
          </p>
          <div className="bg-electric/10 border-l-4 border-electric p-8 my-10 rounded-r-3xl relative overflow-hidden">
            <h4 className="text-white font-black mb-2 uppercase italic text-xl">Dica de Conversão</h4>
            <p className="italic text-white/90">
              "Um site lento mata a venda. Certifique-se de que sua página carregue instantaneamente, especialmente no celular."
            </p>
          </div>
        </div>
      )
    },
    {
      title: "Anatomia da Landing Page de Sucesso",
      type: "grid" as const,
      content: (
        <>
          {[
            { t: "Dobra de Impacto", d: "A primeira coisa que o cliente vê: Título forte, benefícios claros e um botão de ação chamativo.", i: <Target /> },
            { t: "Prova Social", d: "Depoimentos reais de clientes e fotos dos apps P2 PRO em funcionamento em diversas telas.", i: <Star /> },
            { t: "Tabelas de Planos", d: "Apresente seus planos de forma limpa: Mensal, Trimestral e Anual com destaque para o custo-benefício.", i: <Layout /> },
            { t: "Botão WhatsApp", d: "Um botão flutuante de WhatsApp facilita o contato imediato para tirar dúvidas técnicas.", i: <MessageCircle /> },
            { t: "Seção de Dúvidas (FAQ)", d: "Responda as perguntas mais comuns para reduzir o trabalho do seu suporte humano.", i: <Search /> },
            { t: "Segurança e Confiança", d: "Exiba selos de segurança e garantia de satisfação para eliminar o medo do cliente.", i: <ShieldCheck /> }
          ].map((item, i) => (
            <div key={i} className="p-8 rounded-[2.5rem] bg-white/[0.02] border border-white/5 hover:border-electric/30 transition-all group">
              <div className="w-14 h-14 rounded-2xl bg-electric/10 text-electric flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                {item.i}
              </div>
              <h3 className="text-2xl font-black tracking-tighter mb-4 italic uppercase">{item.t}</h3>
              <p className="text-muted-foreground leading-relaxed">{item.d}</p>
            </div>
          ))}
        </>
      )
    },
    {
      title: "Onde Criar seu Site em 2026",
      content: (
        <div className="prose prose-invert max-w-none space-y-6">
          <p className="text-lg text-muted-foreground">
            Você não precisa saber programar. Ferramentas como WordPress (com Elementor), Wix ou até plataformas de Landing Pages facilitam o trabalho. O importante é que a estrutura seja <strong>Mobile First</strong>, já que 90% dos seus leads virão do celular. Como parceiro <strong>P2 PRO</strong>, você tem acesso a modelos de textos e argumentos de vendas validados para usar em seu site.
          </p>
          <div className="p-10 rounded-[3rem] bg-white/[0.02] border border-white/5 my-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-electric/5 blur-[80px] rounded-full" />
            <h4 className="text-2xl font-black mb-6 italic uppercase tracking-tighter flex items-center gap-3">
              <Code className="text-electric w-8 h-8" /> Checklist do Site Master
            </h4>
            <ul className="space-y-4">
              <li className="flex gap-4 items-start">
                <Globe className="text-electric shrink-0 mt-1" />
                <p><span className="text-white font-bold">Domínio Profissional:</span> Tenha um .com ou .com.br com o nome da sua marca. Evite sites gratuitos.</p>
              </li>
              <li className="flex gap-4 items-start">
                <Zap className="text-electric shrink-0 mt-1" />
                <p><span className="text-white font-bold">Certificado SSL:</span> O cadeado de segurança no navegador é obrigatório para passar confiança.</p>
              </li>
              <li className="flex gap-4 items-start">
                <Smartphone className="text-electric shrink-0 mt-1" />
                <p><span className="text-white font-bold">Responsividade:</span> Teste seu site em pelo menos 3 modelos diferentes de celulares.</p>
              </li>
            </ul>
          </div>
          <p className="text-lg text-muted-foreground">
            Um site profissional é a base para qualquer estratégia de tráfego pago (Google Ads/Facebook Ads). Ao investir na sua própria estrutura e combiná-la com o sinal inabalável da <strong>P2 PRO</strong>, você constrói um império de streaming digital sustentável e altamente lucrativo.
          </p>
        </div>
      )
    }
  ];

  return (
    <SEOPage
      category="Dicas Como Revender Iptv"
      title="Como Criar um Site para Captar Clientes IPTV: Guia 2026"
      subtitle="Tenha uma máquina de vendas automática. Aprenda a estruturar uma Landing Page profissional que converte visitantes em assinantes fiéis."
      heroImage="https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=1200"
      introParagraphs={[
        "No mercado digital de 2026, o seu site é a sua sede virtual. É onde você apresenta seus planos, exibe a qualidade do seu sinal P2 PRO e gera a confiança necessária para que o cliente realize o pagamento. Quem depende apenas de mensagens diretas gasta muito tempo repetindo as mesmas informações.",
        "Neste artigo, vamos te mostrar como criar uma estrutura de site que trabalha por você, tirando as dúvidas automáticas e entregando leads prontos para o fechamento no seu WhatsApp.",
        "Com a tecnologia e os materiais de marketing da P2 PRO, seu site terá o visual cinematográfico que os aplicativos exigem, elevando o nível da sua revenda para o status de Master de elite."
      ]}
      benefits={[
        { title: "Automação de Vendas", description: "Seu site educa o cliente e tira dúvidas 24 horas por dia, 7 dias por semana." },
        { title: "Profissionalismo", description: "Ter um site próprio transmite a imagem de uma empresa sólida e confiável." },
        { title: "Controle de Tráfego", description: "Instale pixels de rastreio para fazer remarketing para quem visitou seu site e não comprou." },
        { title: "Independência", description: "Tenha seu próprio canal de vendas que não depende das mudanças de algoritmos das redes sociais." }
      ]}
      howItWorks={[
        { title: "Escolha de Domínio", description: "Defina um nome profissional e registre seu endereço na web." },
        { title: "Estrutura de Conteúdo", description: "Crie textos persuasivos focados em resolver a dor do cliente (preço vs qualidade)." },
        { title: "Design e Layout", description: "Utilize imagens de alta qualidade dos apps P2 PRO e cores modernas." },
        { title: "Integração de Contato", description: "Coloque botões de WhatsApp e formulários de teste grátis em locais estratégicos." }
      ]}
      diferenciais={[
        { title: "Artes de Alta Resolução", description: "Receba imagens em 4K dos nossos apps para usar no banner principal do seu site." },
        { title: "Sinal P2P de Elite", description: "O argumento de venda mais forte do seu site será a estabilidade imbatível da P2 PRO." },
        { title: "Consultoria Master", description: "Saiba quais plataformas de site estão trazendo mais resultados para nossos parceiros." }
      ]}
      faq={[
        { question: "Quanto custa manter um site?", answer: "Uma hospedagem simples custa em média R$ 30 a R$ 50 por mês. Um investimento que se paga com apenas uma ou duas vendas anuais." },
        { question: "Preciso contratar um programador?", answer: "Não necessariamente. Hoje existem criadores de páginas 'arrasta e solta' muito fáceis de usar." },
        { question: "O site ajuda a evitar bloqueios?", answer: "Sim, pois você tem controle total do conteúdo e pode usar páginas de 'ponte' para seus links de pagamento." },
        { question: "Qual a diferença entre Site e Landing Page?", answer: "O site tem várias páginas. A Landing Page é uma página única focada em uma única ação de venda (ideal para IPTV)." },
        { question: "O que é remarketing?", answer: "É mostrar anúncios específicos para pessoas que já visitaram seu site mas ainda não pediram o teste." },
        { question: "Como fazer meu site aparecer no Google?", answer: "Investindo em SEO (conteúdo de blog) ou Google Ads (anúncios pagos por clique)." }
      ]}
      breadcrumbs={breadcrumbs}
      sections={sections}
      ctaTitle="🚀 Construa sua Máquina de Vendas Digital"
      ctaDescription="Combine seu site profissional com o produto premium da P2 PRO e lidere o mercado de streaming."
      ctaButtonText="Quero ser Revendedor Master"
    />
  );
};

export const Route = createFileRoute("/blog/como-criar-site-captar-clientes-iptv")({
  head: () => ({
    meta: [
      { title: "Como Criar um Site para Captar Clientes IPTV: Guia 2026 | P2 PRO" },
      { name: "description", content: "Aprenda a criar um site ou landing page de alta conversão para sua revenda de IPTV. Dicas de design, texto e automação para Masters." },
      { name: "keywords", content: "site para iptv, landing page iptv, como criar site revenda, marketing digital streaming" }
    ],
  }),
  component: ArticlePage,
});